<template>
  <div class="tag-input">
    <el-tag
      :key="tag"
      v-for="tag in tagArray"
      :closable="!disabled"
      :disable-transitions="false"
      @close="handleRemove(tag)"
      >{{ tag }}</el-tag
    >
    <el-input
      class="input-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      @blur="handleInputConfirm"
    ></el-input>
    <el-button class="add-tag-button" v-if="!inputVisible && !disabled" @click="showInput" type="default"
      ><i class="mdi mdi-plus"></i>{{ addTagLabel }}</el-button
    >
  </div>
</template>

<style lang="scss">
.input-tag .el-input__inner {
  height: 32px;
}
</style>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.el-tag {
  height: auto;
  padding: 0 $spacing-unit;
  margin-right: $spacing-unit;
  margin-bottom: $spacing-unit;
  color: $text-color;
  white-space: pre-wrap;
  background: #fff;
  border: 1px solid $border-color;
}

.input-tag {
  width: $spacing-unit * 23;
}

.add-tag-button {
  padding: 0 $spacing-unit;
}
</style>
<script lang="ts">
import type { Input as ElInput } from 'element-ui'
import { defineComponent } from 'vue'

import { trimWithInvisibleChars } from '@/client/utils/string'

export default defineComponent({
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    addTagText: String,
    disabled: {
      type: Boolean,
      default: false
    },
    onChange: Function
  },
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      tagArray: Object.assign([], this.tags)
    }
  },
  computed: {
    addTagLabel(): string {
      return this.addTagText || '追加'
    }
  },
  watch: {
    tags() {
      this.tagArray = Object.assign([], this.tags)
    }
  },
  methods: {
    handleRemove(tag: string) {
      this.tagArray.splice(this.tagArray.indexOf(tag), 1)
      // disabled で使う呼び出し元は onChange を渡さない
      this.onChange?.(this.tagArray)
    },
    handleInputConfirm() {
      const inputValue = trimWithInvisibleChars(this.inputValue)
      if (!this.inputValue || this.tagArray.indexOf(inputValue) >= 0) {
        this.inputVisible = false
        return
      }
      this.tagArray.push(inputValue)
      this.inputVisible = false
      this.inputValue = ''
      this.onChange?.(this.tagArray)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        const saveTagInput = this.$refs.saveTagInput as ElInput
        ;(saveTagInput.$refs.input as HTMLInputElement).focus()
      })
    }
  }
})
</script>
